const aboutUsJson = {
    "banner": './images/about-us/banner.jpg',
    "mobbanner": './images/about-us/mob/banner.png',
    "title": '关于我们',
    "tag": '喜得 是一家创新设计公司',
    "btnText": '联系我们',
    "btnLink": '/contact-us',
    "list": [
        {
            "id": 1,
            "type": "text",
            "title": "关于我们",
            "section": [
                {
                    "id": 1,
                    "text": "喜得为企业客户提供创新设计咨询及开发集成服务，为其创造非同凡响的客户体验，提升运营效率，创造有竞争力的商业价值。"
                },
                {
                    "id": 2,
                    "text": "我们的解决方案聚焦行业应用，结合最前沿的创新科技，运用人工智能，人脸识别，AR增强现实，智能眼镜等先进技术或科技产品，打造以客户为中心的全新业务体验，降低商业成本，提升运营效率。"
                },
                {
                    "id": 3,
                    "text": "凭借丰富的行业经验，喜得已在电信、金融、保险、文体娱乐等行业拥有成熟的解决方案。"
                },
                {
                    "id": 4,
                    "text": "喜得尊重每一个客户的业务发展与市场商业属性，我们始终相信企业创新的一小步会带来行业的一大步。"
                }

            ]
        },
        {
            "id": 2,
            "type": "text",
            "title": "团队介绍",
            "section": [
                {
                    "id": 1,
                    "text": "一些具有体验设计咨询10年以上经验的顾问、设计师、架构师。"
                },
                {
                    "id": 2,
                    "text": "一些信奉体验设计/服务设计理念的理想主义者。"
                },
                {
                    "id": 3,
                    "text": "一些坚信体验设计/服务设计可以为客户创造卓越价值的实践者。"
                },
                {
                    "id": 4,
                    "text": "一些热衷于促进设计服务在中国蓬勃发展的坚定推动者。"
                },

            ]
        }
    ],
    "member": [
        {
            "id": 1,
            "name": '',
            "post": '资深行业专家',
            "photo": './images/about-us/sketch/lc.png',
        },{
            "id": 2,
            "name": '',
            "post": '资深咨询顾问',
            "photo": './images/about-us/sketch/dong.png',                
        },{
            "id": 3,
            "name": '',
            "post": '创意总监',
            "photo": './images/about-us/sketch/qiao.png',
        },{
            "id": 4,
            "name": '',
            "post": '系统架构师',
            "photo": './images/about-us/sketch/qing.png',
        },{
            "id": 5,
            "name": '前端开发',
            "post": '工程师',
            "photo": './images/about-us/sketch/thor.png',                
        },{
            "id": 6,
            "name": '',
            "post": '体验设计师',
            "photo": './images/about-us/sketch/qi.png',
        },{
            "id": 7,
            "name": '后台开发运营',
            "post": '工程师',
            "photo": './images/about-us/sketch/orange.png',                
        },{
            "id": 8,
            "name": 'Android/IOS',
            "post": '开发工程师',
            "photo": './images/about-us/sketch/tiger.png',                
        }
    ]
};

export default aboutUsJson
